import { Model } from '@shared/models/model';
import { Expose } from 'class-transformer';

export class BusinessUnitStatus extends Model {

    @Expose()
    averageCustomerCost: number;

    @Expose()
    receiversCount: number;
}
